export enum PersonTypeEnum{
    Employee  = "E",
    ContingentLabor = "C",
    Applicant = "A",
    Student = "S"
}